export default "__VITE_ASSET__CcKVpsyO__"